import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7341a550"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fz-14 lh-36" }
const _hoisted_2 = { class: "fz-14 lh-36" }
const _hoisted_3 = { class: "fixed print-box" }
const _hoisted_4 = { id: "printBox" }
const _hoisted_5 = { class: "flex-row-start-sb" }
const _hoisted_6 = { class: "flex-1" }
const _hoisted_7 = { class: "font-blod title" }
const _hoisted_8 = { class: "flex-row info-box" }
const _hoisted_9 = { class: "flex-row-center-start info-box-item" }
const _hoisted_10 = { class: "co-949CA9" }
const _hoisted_11 = { class: "flex-row-center-start info-box-item" }
const _hoisted_12 = { class: "co-949CA9" }
const _hoisted_13 = { class: "flex-row-center-start info-box-item" }
const _hoisted_14 = { class: "co-949CA9" }
const _hoisted_15 = { class: "flex-row-center-start info-box-item" }
const _hoisted_16 = { class: "co-949CA9" }
const _hoisted_17 = { class: "ml-60" }
const _hoisted_18 = { class: "flex-row-center-start info-box-item" }
const _hoisted_19 = { class: "co-949CA9" }
const _hoisted_20 = { class: "flex-row-center-start info-box-item" }
const _hoisted_21 = { class: "co-949CA9" }
const _hoisted_22 = { class: "flex-column flex-align-end" }
const _hoisted_23 = { class: "flex-column-center-center" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "order_sn co-1F2D48" }
const _hoisted_26 = { class: "status_text font-blod co-FF8700" }
const _hoisted_27 = {
  class: "flex-row-center-sb td-title font-blod",
  style: {"margin-top":"1mm"}
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-row-center-center index" }, "序号", -1))
const _hoisted_29 = { class: "flex-row-center-center flex-1" }
const _hoisted_30 = { class: "flex-row-center-center flex-1" }
const _hoisted_31 = { class: "flex-row-center-center number" }
const _hoisted_32 = { class: "flex-row-center-center flex-1" }
const _hoisted_33 = { class: "flex-row-center-center index" }
const _hoisted_34 = { class: "flex-row-center-center flex-1" }
const _hoisted_35 = { class: "flex-row-center-center flex-1" }
const _hoisted_36 = { class: "two-row good_sn" }
const _hoisted_37 = { class: "flex-row-center-center flex-1" }
const _hoisted_38 = { class: "three-row" }
const _hoisted_39 = { class: "flex-row-center-center date" }
const _hoisted_40 = { class: "flex-row-center-center unit" }
const _hoisted_41 = { class: "flex-row-center-center number" }
const _hoisted_42 = { class: "flex-row-center-center flex-1" }

import { ref, watch, getCurrentInstance } from 'vue';
	import translate from "@/api/translate";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'PrintOrderInfo',
  props: {
		text: {
			type: String,
			default: "",
		},
		SelectArr: {
			type: Array,
			default: function () {
				return []
			},
		},
		list: {
			type: Array,
			default: function () {
				return []
			},
		},
		name: {
			type: String,
			default: "",
		}
	},
  setup(__props) {

	const props = __props;

	const { proxy } = getCurrentInstance() as any;
	const PrintArr = ref<any>([]);
	const print = ref<any>({
		id: 'printBox',//这里的id就是上面我们的打印区域id，实现指哪打哪
		popTitle: '', // 打印配置页上方的标题
		extraCss: "", // 打印可引入外部的一个 css 文件
		extraHead: ' ', // 最上方的头部文字，附加在head标签上的额外标签，使用逗号分割
		preview: false, // 是否启动预览模式，默认是false
		previewTitle: ' ', // 打印预览的标题
		previewPrintBtnLabel: ' ', // 打印预览的标题下方的按钮文本，点击可进入打印
		zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
	});

	watch(() => props.SelectArr, (n : any) => {
		PrintArr.value = n;
	}, {
		immediate: true,
	});

	const StartPrint = () => {
		proxy.$message.warning(translate.ShowText('请选择货位')); // 请选择货位
	};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_print = _resolveDirective("print")!

  return (_openBlock(), _createElementBlock("div", null, [
    (PrintArr.value.length > 0)
      ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          class: "print-btn",
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(__props.text), 1)
          ]),
          _: 1
        })), [
          [_directive_print, print.value]
        ])
      : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          class: "print-btn",
          type: "primary",
          onClick: StartPrint
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(__props.text), 1)
          ]),
          _: 1
        })),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(PrintArr.value, (v, i) => {
          return (_openBlock(), _createElementBlock("div", {
            style: {"page-break-after":"always"},
            key: i
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(__props.name), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(translate).ShowText('入库单号')) + "：", 1),
                      _createElementVNode("div", null, _toDisplayString(v.order_sn), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(translate).ShowText('入库类型')) + "：", 1),
                      _createElementVNode("div", null, _toDisplayString(v.type_text), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(translate).ShowText('订单来源')) + "：", 1),
                      _createElementVNode("div", null, _toDisplayString(v.add_type_text), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(translate).ShowText('存储仓库')) + "：", 1),
                      _createElementVNode("div", null, _toDisplayString(v.warehouse_text), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(translate).ShowText('创建人')) + "：", 1),
                      _createElementVNode("div", null, _toDisplayString(v.admin_name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(translate).ShowText('创建时间')) + "：", 1),
                      _createElementVNode("div", null, _toDisplayString(v.create_time), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("img", {
                    class: "code_url",
                    src: v.barcode_url,
                    alt: ""
                  }, null, 8, _hoisted_24),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(v.order_sn), 1)
                ]),
                _createElementVNode("div", _hoisted_26, _toDisplayString(v.status_text), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(translate).ShowText('商品唯一码')), 1),
              _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(translate).ShowText('商品SKU')), 1),
              _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(translate).ShowText('预报数量')), 1),
              _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(translate).ShowText('备注')), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (v, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex-row-center-sb td-title ali-stretch",
                style: {"border-bottom":"0.01mm solid #F7F7F7"},
                key: i
              }, [
                _createElementVNode("div", _hoisted_33, _toDisplayString(i + 1), 1),
                _createElementVNode("div", _hoisted_34, _toDisplayString(v.good_batch_sn), 1),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("span", _hoisted_36, _toDisplayString(v.good_sn), 1)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("span", _hoisted_38, _toDisplayString(v.good_name), 1)
                ]),
                _createElementVNode("div", _hoisted_39, _toDisplayString(v.good_quality_day), 1),
                _createElementVNode("div", _hoisted_40, _toDisplayString(v.good_unit), 1),
                _createElementVNode("div", _hoisted_41, _toDisplayString(v.number), 1),
                _createElementVNode("div", _hoisted_42, _toDisplayString(v.remark), 1)
              ]))
            }), 128))
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})